import chroma from 'chroma-js';
import classnames from 'classnames';
import React from 'react';

import cs from './styles.module.scss';

export interface PillSelectOption<T extends string = string> {
  label: string;
  value: T;
}

interface Props<T extends string> {
  options: PillSelectOption<T>[];
  value: T | null;
  onChange: (value: T) => void;
  disabled?: boolean;
  accentColor?: string;
}

function PillSelect<T extends string>({
  options,
  value,
  onChange,
  disabled,
  accentColor,
}: Props<T>): React.ReactElement {
  const selectedStyle = accentColor
    ? {
        borderColor: accentColor,
        color: accentColor,
        backgroundColor: chroma(accentColor).alpha(0.1).css(),
      }
    : undefined;

  return (
    <div className={cs.pillSelect} role="radiogroup">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={option.value === value}
          className={classnames(cs.pill, {[cs.pillSelected]: option.value === value})}
          style={option.value === value ? selectedStyle : undefined}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default PillSelect;
